import React from 'react';

import { Call } from '../../call';
import { CallView } from '../../pages/CallView/CallView';
import { useSound } from '../AudioProvider/useSound';
import { useSounds } from '../AudioProvider/SoundsProvider';

export interface CallControllerProps {
    call: Call;
    type: 'incoming' | 'outgoing';

    onHang?: VoidFunction;
}

export const CallController: React.FC<CallControllerProps> = (props) => {
    const [state, setState] = React.useState<'incoming' | 'outgoing' | 'active'>(props.type);
    const [playAbonent, abonentSoundController] = useSound(props.call.audio);
    const sounds = useSounds();

    React.useEffect(() => {
        if (state === 'outgoing') {
            // 2-4s
            const timeToCall = Math.floor(Math.random() * 2000 + 2000);
            const timeout = setTimeout(() => setState('active'), timeToCall);
            const fuckingTimeout = setTimeout(() => sounds.beeps.play(), 5);

            return () => {
                clearTimeout(timeout);
                clearTimeout(fuckingTimeout);
                sounds.beeps.controller.stop();
            };
        } else if (state === 'incoming') {
            sounds.ringtone.play();
            return () => {
                sounds.ringtone.controller.stop();
            };
        } else if (state === 'active') {
            playAbonent();

            return () => {
                abonentSoundController.stop();
            };
        }
    }, [state]);

    const onHang = React.useCallback(() => {
        sounds.hang.play();

        setTimeout(() => sounds.hang.controller.stop(), 1000);
        if (props.onHang) {
            props.onHang();
        }
    }, [props.onHang]);

    return (
        <CallView
            image={props.call.image}
            name={props.call.personName}
            layout={state === 'incoming' ? 'incoming_accept_double' : state}

            onAccept={() => setState('active')}
            onHang={onHang}
        />
    );
};
